export default __webpack_public_path__ + "static/media/prize5.e4b880d9.svg";